import { lazy, type LazyExoticComponent } from 'react';

import type { ActionKeys } from '@atlassian/conversation-assistant-message-actions-api/constants';
import type { ActionRendererFor } from '@atlassian/conversation-assistant-message-actions-api/types';

export const SlackSendChannelMessageRendererAsync: LazyExoticComponent<
	(props: ActionRendererFor<typeof ActionKeys.SlackSendChannelMessage>) => React.JSX.Element | null
> = lazy(() =>
	import(
		/* webpackChunkName: "@atlassian/conversation-assistant-message-actions/slack-send-channel-message" */ './SlackSendChannelMessageAction'
	).then((m) => ({ default: m.SlackSendChannelMessageAction })),
);
